import { render, staticRenderFns } from "./SwitchPopModal.vue?vue&type=template&id=5a6b1b7d"
import script from "./SwitchPopModal.vue?vue&type=script&lang=js"
export * from "./SwitchPopModal.vue?vue&type=script&lang=js"
import style0 from "./SwitchPopModal.vue?vue&type=style&index=0&id=5a6b1b7d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports